module.exports = __webpack_public_path__ + "img/home_final.d3075735.jpg";